
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import get from 'lodash/get';

import Attribute from './objectInfo/Attribute';

let resolve;

class DialogObjectInfo extends Component {

    classNames = mergeStyleSets({
        title: {
            fontWeight: 'bold'
        },
        pivotItemContent: {
            paddingTop: 8
        }
    });

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogObjectInfo/>, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            lightboxOpen: false,
            message: '',
            objects: []
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown, true);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown, true);
    }

    getMapLayerById(layers, layerId) {
        let mapLayer = null;
        if (layerId) {
            layers.forEach(item => {
                if (layerId.endsWith(item.id)) {
                    mapLayer = item;
                }
            });
        }
        return mapLayer;
    }

    getObjectInfoDefinition(object) {
        if (object && object.attributes && object.attributes._info) {
            return object.attributes._info;
        }
        if (object && object.mapLayer) {
            return object.mapLayer.info;
        }
        return null;
    }

    getMinWidth = () => {
        let dialogMinWidth = get(this.state.appConfig, 'info.dialogMinWidth', 700);
        this.state.objects.map(item => {
            const infoDefinition = this.getObjectInfoDefinition(item);
            if (infoDefinition && infoDefinition.dialogMinWidth) {
                dialogMinWidth = Math.max(dialogMinWidth, infoDefinition.dialogMinWidth);
            }
        });
        return dialogMinWidth;
    }

    getModalProps = () => {
        const isModeless = get(this.state.appConfig, 'info.isModeless', true);
        const modalProps = isModeless
            ? {
                isModeless: true,
                dragOptions: {}
            }
            : {
                isModeless: false,
                isDarkOverlay: false,
                dragOptions: {}
            }
        return modalProps;
    }

    hasObjectInfo(object) {
        return !!this.getObjectInfoDefinition(object);
    }

    handleCancel = () => {
        this.setState({
            hidden: true,
            lightboxOpen: false,
            message: '',
            objects: []
        });
        if (resolve) {
            resolve(false);
        }
    }

    handleKeyDown = (event) => {
        const isDialogVisible = !this.state.hidden && this.state.objects && this.state.objects.length > 0;
        if (isDialogVisible && !this.state.lightboxOpen && (event.key === 'Escape' || event.keyCode === 27)) {
            event.preventDefault();
            event.stopPropagation();
            this.handleCancel();
        }
    }

    handleLightboxOpenChange = (lightboxOpen) => {
        this.setState({lightboxOpen});
    }

    render() {
        if (this.state.objects && this.state.objects.length > 0) {
            return this.renderDialog();
        } else {
            return null;
        }
    }

    renderDialog () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={this.getMinWidth()}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal
                }}
                modalProps={this.getModalProps()}
                >
                {this.state.objects && this.renderObjects()}
                <DialogFooter>
                    <Stack horizontal>
                        <Stack.Item>
                            {this.state.message && this.renderMessage()}
                        </Stack.Item>
                        <Stack.Item grow>
                            {''}
                        </Stack.Item>
                        <DefaultButton onClick={this.handleCancel} text="Zavřít" />
                    </Stack>
                </DialogFooter>
            </Dialog>
        );
    }

    renderAttributes = (infoDefinition, attributes) => {
        let result = [];
        if (infoDefinition) {
            infoDefinition.attributes.forEach((item, index) => {
                let canRender = item.hidden !== true;
                if (item.emptyHidden) {
                    if (!attributes[item.name]) {
                        canRender = false;
                    }
                }
                if (canRender) {
                    result.push(
                        <Attribute
                            appConfig={this.state.appConfig}
                            definition={item}
                            infoDefinition={infoDefinition}
                            values={attributes}
                            key={index}
                            onCloseDialog={this.handleCancel}
                            onLightboxOpenChange={this.handleLightboxOpenChange}
                        />
                    );
                }
            });
        }
        return result;
    }

    renderMessage = () => {
        return (
            <div>{this.state.message}</div>
        );
    }

    renderObjects = () => {
        return (
            <Pivot>
                {this.state.objects.map(item => {
                    if (this.getObjectInfoDefinition(item) && this.getObjectInfoDefinition(item).title) {
                        return this.renderObject(item);
                    } else {
                        return null;
                    }
                })}
            </Pivot>
        );
    }

    renderObject = (object) => {
        const infoDefinition = this.getObjectInfoDefinition(object);
        return (
            <PivotItem headerText={infoDefinition.title} key={object.layerId}>
                <div className={this.classNames.pivotItemContent}>
                    {this.renderAttributes(infoDefinition, object.attributes)}
                </div>
            </PivotItem>
        );
    }

    show(layers, layerId, attributes, appConfig) {
        this.setState({
            appConfig: appConfig,
            hidden: false,
            lightboxOpen: false,
            objects: [{
                layerId: layerId,
                attributes: attributes,
                mapLayer: this.getMapLayerById(layers, layerId)
            }].filter(item => this.hasObjectInfo(item))
        });
        return new Promise((res) => {
            resolve = res;
        });
    }

    showMessage(message) {
        this.setState({
            hidden: false,
            message: message
        });
        resolve = null;
    }

    showObjects(layers, objects, appConfig) {
        this.setState({
            appConfig: appConfig,
            hidden: false,
            lightboxOpen: false,
            objects: objects.map(item => {
                return {
                    ...item,
                    mapLayer: this.getMapLayerById(layers, item.layerId)
                }
            }).filter(item => this.hasObjectInfo(item))
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogObjectInfo.create();
